if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      // if this main product form
      this.formId = this.getAttribute('data-product-form-id');
      if (this.formId) {
        this.form = document.getElementById(this.formId);
      } else {
        this.form = this.querySelector('form');
      }

      this.form.querySelector('[name=id]').disabled = false;

      // check if this sticky bar form and product with subscription
      if (this.hasAttribute('data-sticky-form-trigger')){
        this.form.addEventListener('submit', this.onSubmitStickyBar.bind(this));
      } else {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartDrawer.setActiveElement(document.activeElement);


      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    onSubmitStickyBar(evt) {
      evt.preventDefault();

      this.triggerFormId = this.getAttribute('data-sticky-form-trigger');
      this.triggerForm = document.getElementById(this.triggerFormId);
      this.triggerFromBtn = this.triggerForm.querySelector('[type=submit]')
      if (this.triggerFromBtn) this.triggerFromBtn.click();
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || $(this).parents(".CardItem").find(".product-form__error-message-wrapper")[0];
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message') || $(this).parents(".CardItem").find(".product-form__error-message");
      this.stickyErrorMessageWrapper = document.querySelector('.sticky-product-form__error-message-wrapper');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        this.errorMessage.focus();
      }

      if ($(this.errorMessageWrapper).hasClass('main-product-form__error-message-wrapper')) {
        if (this.stickyErrorMessageWrapper) {
          this.stickyErrorMessage = this.stickyErrorMessageWrapper.querySelector('.product-form__error-message');
        }

        if (errorMessage && this.stickyErrorMessageWrapper) {
          this.stickyErrorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          this.stickyErrorMessage.textContent = errorMessage;
          this.errorMessage.focus();
        }
      }
    }
  });
}
